import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.teams',
		defaultMessage: 'Teams',
		description:
			'The text is shown as a navigation link label in the global shortcuts menu when the user opens the shortcut menu. This link navigates the user to the Teams application.',
	},
});
